import React from 'react'
import styled from '@emotion/styled'
import type { BetSlipItem } from '@mobi/betslip/types'
import { isFobDetails, isRaceDetails } from '@mobi/betslip/helpers/typeGuards'
import { spacing } from '@mobi/component-library/Theme/Common'
import type { QuickbetState } from '@core/Areas/Quickbet/driver'
import { MarketPillStyled } from '../BetInfoHeader/Components/Common/Header.styles'
import { RacingHeader } from './Components/RacingHeader'
import { FobHeader } from './Components/FobHeader'

export const MultiHeader: React.FC<{ legs: NonNullable<QuickbetState['selectionMultiLegs']> }> = ({
  legs,
}) => {
  return (
    <WrapperStyled>
      <MarketPillStyled>Multi</MarketPillStyled>

      {legs.map(item => (
        <HeaderItem item={item} key={item.id} />
      ))}
    </WrapperStyled>
  )
}

// ===============
// Local Component
// ===============

const HeaderItem: React.FC<{ item: BetSlipItem }> = ({ item }) => {
  if (isRaceDetails(item.selectionDetails)) {
    return (
      <RacingHeader
        key={item.id}
        selection={item.selection}
        races={item.selectionDetails.races}
        acceptors={item.selectionDetails.acceptors}
        betLegType={item.multiLegBetType}
      />
    )
  }

  if (isFobDetails(item.selectionDetails)) {
    return <FobHeader selectionDetails={item.selectionDetails} betLegType={item.multiLegBetType} />
  }

  return null
}

// ======
// Styles
// ======

const WrapperStyled = styled.div({
  display: 'flex',
  flexDirection: 'column',
  gap: spacing.smx1,
})
